import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbreact/dist/css/mdb.css'
import './global.scss'
import wrapWithProvider from './wrap-with-provider'
export const wrapRootElement = wrapWithProvider
